export default "__VITE_ASSET__a8bc5208__"